export type SectorListView = "opportunities" | "companies" | "collaboration-models";

export type SectorListViewConfig = {
  title: string;
  subtitle: string;
  pathSegment: string;
  filterParam?: "subIndustry" | "collaborationIntent";
};

export const SECTOR_LIST_VIEW_CONFIG: Record<SectorListView, SectorListViewConfig> = {
  opportunities: {
    title: "Opportunities",
    subtitle: "What companies are looking for.",
    pathSegment: "opportunities",
    filterParam: "subIndustry",
  },
  companies: {
    title: "Companies",
    subtitle: "Who is participating.",
    pathSegment: "companies",
  },
  "collaboration-models": {
    title: "Collaboration Models",
    subtitle: "How companies want to work together.",
    pathSegment: "collaboration-models",
    filterParam: "collaborationIntent",
  },
};

export function sectorListPath(slug: string, view: SectorListView): string {
  return `/sector/${encodeURIComponent(slug)}/${SECTOR_LIST_VIEW_CONFIG[view].pathSegment}`;
}

export function resolveSectorListViewFromPath(pathname: string): SectorListView | null {
  if (pathname.endsWith("/opportunities")) return "opportunities";
  if (pathname.endsWith("/collaboration-models")) return "collaboration-models";
  if (pathname.endsWith("/companies")) return "companies";
  return null;
}

export function sectorListLoginState(slug: string, view: SectorListView) {
  const pathname = sectorListPath(slug, view);
  return { from: { pathname, search: "", hash: "" } };
}

export type SectorListFooterLink = {
  footerTo: string;
  footerLinkState?: { from: { pathname: string; search?: string; hash?: string } };
};

/** Logged-in users go to the listing page; guests are sent to login with return path. */
export function sectorListFooterLink(slug: string, view: SectorListView, isAuthenticated: boolean): SectorListFooterLink {
  const target = sectorListPath(slug, view);
  if (isAuthenticated) {
    return { footerTo: target };
  }
  return { footerTo: "/login", footerLinkState: sectorListLoginState(slug, view) };
}
